import Api from '@/services/Api'

export default {
  getCampuses () {
    return Api().get('/api/v1/campuses')
  },

  addCampus (params) {
    return Api().post('/api/v1/campuses', params, {
      withCredentials: true
    })
  },

  updateCampus (params) {
    return Api().put(`/api/v1/campuses/${params._id}`, params, {
      withCredentials: true
    })
  },

  getCampus (id) {
    return Api().get(`/api/v1/campuses/${id}`)
  },

  deleteCampus (id) {
    return Api().delete(`/api/v1/campuses/${id}`, {
      withCredentials: true
    })
  }
}
